import React from "react";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";
import Leftnav from "../components/Leftnav";

const Main = () => {
  return (
    <div>
      <Header></Header>
      <div className="grid md:grid-cols-4 sm:grid-cols-1">
        <div className="border-teal-300 text-3xl">
          <Leftnav></Leftnav>
        </div>
        <div className="md:col-span-3">
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};

export default Main;
